import React from 'react';
import { motion } from 'framer-motion';

const tutors = [
  {
    id: 'hamza',
    label: 'A-Levels with Hamza',
    name: 'Hamza Munum',
    role: 'A-Level Biology and Chemistry Tutor',
    image: '/images/tutor-main.jpeg',
    bio: [
      "I'm a 3rd-year medical student with a strong academic background and a passion for helping students succeed. I completed my GCSEs in 2020 and my A-Levels in 2022, and since then I've been tutoring GCSE and A-Level Biology and Chemistry.",
      "With years of experience and a deep understanding of the UK curriculum, I know exactly how demanding exams can be — and I use my own journey to guide students with clarity, confidence, and proven strategies.",
    ],
  },
  {
    id: 'fatima',
    label: 'GCSE with Fatima',
    name: 'Fatima Zainab',
    role: 'GCSE Biology and Chemistry Tutor',
    image: '/images/fatima.jpeg',
    bio: [
      "As a qualified medical doctor (MBBS) who relocated to the UK, I bring three years of dedicated GCSE teaching experience to our team. I have an in-depth, specification-first knowledge of both GCSE Biology and Chemistry. My focus is on breaking down complex science into simple, memorable steps so students can confidently master their exams.",
    ],
  },
];

const TutorBlock = ({ tutor, reverse }) => {
  return (
    <div
      className={`grid md:grid-cols-2 gap-12 lg:gap-20 items-center ${
        reverse ? 'md:[&>*:first-child]:order-2' : ''
      }`}
    >
      <motion.div
        initial={{ opacity: 0, x: reverse ? 40 : -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="aspect-[4/5] w-full max-w-[460px] mx-auto md:mx-0 rounded-3xl overflow-hidden bg-neutral-100">
          <img
            src={tutor.image}
            alt={`${tutor.name} — ${tutor.role}`}
            loading="eager"
            decoding="async"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="mt-6 md:max-w-[460px] mx-auto md:mx-0 text-center">
          <div className="font-display text-[18px] font-semibold text-neutral-900">
            {tutor.name}
          </div>
          <div className="text-[13px] text-neutral-500 mt-1">{tutor.role}</div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: reverse ? -40 : 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      >
        <div className="text-[12px] tracking-[0.22em] uppercase text-neutral-500">
          {tutor.label}
        </div>
        <h3 className="mt-4 font-display text-[32px] md:text-[44px] leading-[1.05] tracking-tight font-semibold text-neutral-900">
          {tutor.name}
        </h3>
        <div className="mt-8 space-y-5 text-[15px] leading-[1.7] text-neutral-700 max-w-lg">
          {tutor.bio.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

const MeetTutor = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center font-display text-[44px] md:text-[60px] leading-[1.05] tracking-tight font-semibold text-neutral-900"
        >
          Meet your tutors.
        </motion.h2>

        <div className="mt-16 md:mt-24 space-y-24 md:space-y-32">
          {tutors.map((tutor, i) => (
            <TutorBlock key={tutor.id} tutor={tutor} reverse={i % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetTutor;
